import * as React from "react";

import ProjectsTable from "./ProjectsTable";

import AppPage from "@/ui/AppPage/AppPage";

function ProjectsPage() {
  return (
    <AppPage>
      <ProjectsTable />
    </AppPage>
  );
}

export default ProjectsPage;
